import {
  Component,
  HostBinding,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UmssIconComponent } from '../icon/icon.component';

@Component({
  selector: 'umss-icon-button',
  standalone: true,
  imports: [CommonModule, UmssIconComponent],
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss']
})
export class UmssIconButtonComponent {
  @HostBinding('style.display') display = 'contents';

  constructor() {}

  /** Icon props - Direct Phosphor icon integration */
  @Input() iconName?: string; // Phosphor icon name (e.g., 'phosphorHeart', 'phosphorX')
  @Input() iconSize?: string; // Icon size (default based on button size)
  @Input() iconColor?: string; // Icon color (defaults to currentColor)
  @Input() ariaLabel?: string;

  /** Variant props - Well-typed and comprehensive */
  @Input() variant:
    | 'Primary'
    | 'Secondary'
    | 'Destructive'
    | 'Outline'
    | 'Ghost' = 'Primary';
  @Input() size: 'Mini' | 'Small' | 'Regular' | 'Large' = 'Regular';

  /** State props - Simple and clear */
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;

  /** Events - Proper event handling */
  @Output() onClick = new EventEmitter<MouseEvent>();

  onButtonClick(event: MouseEvent) {
    if (!this.disabled && !this.loading) {
      this.onClick.emit(event);
    }
  }

  get computedIconSize(): string {
    if (this.iconSize) return this.iconSize;

    // Default icon sizes based on button size
    switch (this.size) {
      case 'Mini':
        return '12px';
      case 'Small':
        return '16px';
      case 'Regular':
        return '20px';
      case 'Large':
        return '24px';
      default:
        return '20px';
    }
  }
}
